const SUPPORTE_LANGUAGES = ['en', 'zh'];
const RESOURCES = {
  zh: {
    'DISCOVER & BOOK': '立即预订',
    Activities: '景点',
    'Attractions & Events': '景点与活动',
    Amenities: '设施',
    Transport: '交通',
    Food: '餐饮',
    Services: '服务',
    AMENITIES: '设施',
    ACTIVITIES: '景点',
    'ATTRACTIONS & EVENTS': '景点与活动',
    BOOK: '预订',
    'FULLY BOOKED': '预订已满',
    RESERVE: '订位',
    ORDER: '点餐',
    'SEE MORE': '查看更多',
    'Entertainment and enjoyment for everyone': '合家共享的游乐园设施',
    'Changi Experience Studio': '樟宜时空体验馆',
    JEWEL: '星耀樟宜',
    'A first- of - its - kind attraction':
      'A first - of - its - kind attraction',
    'https://www.jewelchangiairport.com/en/attractions/ces.html':
      'https://www.jewelchangiairport.com/zh/attractions/ces.html',
    'https://www.jewelchangiairport.com/en/attractions/ces.html#CESpromotion':
      'https://www.jewelchangiairport.com/zh/attractions/ces.html',
    'Canopy Park & More': '星空乐园与其他游乐设施',
    'For the young and young at heart': 'For the young and young at heart',
    'https://www.jewelchangiairport.com/en/ticketing.html':
      'https://www.jewelchangiairport.com/zh/ticketing.html',
    'RECOMMENDED FOR YOU': '诚心推荐',
    'Sept Out & Play (Indoor Playground)': 'Sept Out & Play (室内游乐场)',
    'Redemptions at T3': '前往T3获取兑换卷',
    'Enjoy 50% Off Canopy': '半价优惠:星空花园',
    'Park Adult Bundle': '成人配套1及3',
    'Canopy Park': '星空花园',
    '4 Sep - 4 Oct': '9月4日至10月4日',
    'Redemptions at T3': '前往T3获取兑换卷',
    'From 1 Oct to 31 Oct': '10月1日至10月31日',
    '50% Off Child Tickets': '购买成年票；享受',
    'With Purchase Of': '50%儿童票折扣',
    'Adult Ticket': ' ',
    'Package 1 Or 3': ' ',
    'FIND OUT MORE': '了解更多',
    'MORE INFO': '了解更多',
    'Glampcation in the Clouds': '星空豪华露营',
    'Glampcation at Shiseido Forest Valley': '资生堂森林谷豪华露营',
    'A Night at the Airport Family Camp': '奇妙机场两天一夜家庭营',
    'Changi Experience Studio Play + Sleepover': '时空体验欢乐营',
    'Glampicnic in the Clouds': '豪华野餐',
    'Workshops & Activities': '活动与工作坊',
    'Jurassic Mile': '侏罗纪步道',
    'Jewel Changi Airport': '星耀樟宜',
    'Jewel Wilderness Explorer Learning Journey – Ages 7 to 12': '星耀樟宜野外之旅-适合年龄:7至12岁',
    'Till 31 Dec 2021': '至12月31日',
    "HERSHEY'S Roller Rink": "HERSHEY'S 轮滑场",
    '12 Mar to 3 May 2021': "3月12日至5月3日",
    'T3, Lvl 2 (Near Row 11)': "T3, Lvl 2 (11登机通道)",
    TRANSPORT: '交通',
    'A RIDE DOWNTOWN OR PLACE TO PARK?': '需要接送或者寻找停车位？',
    'Hassle-free transfer from Changi Airport to most downtown hotels in Singapore':
      '更容易地往返机场！',
    'City Shuttle & Limo': '班车服务',
    'https://changi.groundtransportconcierge.com':
      'https://changi.groundtransportconcierge.com',
    'Taking a short trip?': '短途旅行？',
    'Enjoy parking discounts at Changi when you fly':
      '当您旅行时可购买优惠停车配套',
    'Park & Fly Coupon': 'Park & Fly 停车券',
    'https://www.ishopchangi.com/category/travel/parking-1645/park-fly-coupons-1646#1':
      'https://zh.ishopchangi.com/category/travel/parking-1645/park-fly-coupons-1646#1',
    'FREE Parking Promotion': '免费停车活动',
    'Dine on weekdays to redeem 2 hours FREE parking!':
      '工作日在机场用餐可兑换两小时免费停车券！',
    'Enjoy preferential rates when you book your parking with us':
      '预订停车场时享受优惠价格',
    'Park & Dine Coupon': 'Park & Dine 停车券',
    'https://playpass.changiairport.com/#/carparkpromo2020/?source=ichangi':
      'https://playpass.changiairport.com/#/carparkpromo2020/?source=ichangi',
    FOOD: '餐饮',
    'QUICK RESERVATION & ORDERS': '快速订位或点餐',
    'Changi Airport’s got you covered, finding a spot to satisfy your cravings is just plane simple!':
      '樟宜机场可以帮助您找到所需的就餐地点',
    'Use Waitrr to order takeaway ahead of time to skip the line,  or for dining in to skip waiting for service.':
      '使用Waitrr可以提前点外卖，以免排队，或避免等候就餐',
    'Hassle-free dining at your favourite places':
      '轻而易举地在您最喜欢的餐厅用餐',
    'Chope your table': '预订座位',
    'https://www.changiairport.com/en/dine/chopeatchangi.html':
      'https://www.changiairport.com/zh/dine/chopeatchangi.html',
    SERVICES: '服务',
    'NEED A HELPING HAND?': '需要帮助吗？',
    'Making sure you have a stress-free journey': '让您的假期通行无阻',
    Wheelchair: '轮椅租借',
    'https://www.changiairport.com/en/airport-guide/facilities-and-services/wheelchair-rental.html':
      'https://www.changiairport.com/zh/airport-guide/facilities-and-services/wheelchair-rental.html',
    'http://www.changiairport.com/en/airport-guide/special-assistance.html#anchorAssistanceforPeoplewithRestrictedMobility':
      'http://www.changiairport.com/en/airport-guide/special-assistance.html#anchorAssistanceforPeoplewithRestrictedMobility',
    Porter: '行李搬运',
    'https://www.changiairport.com/en/airport-guide/facilities-and-services/porter-service.html':
      'https://www.changiairport.com/zh/airport-guide/facilities-and-services/porter-service.html',
    'https://www.changiairport.com/en/airport-guide/special-assistance.html#anchorAssistanceforPeoplewithRestrictedMobility':
      'https://www.changiairport.com/zh/airport-guide/special-assistance.html#anchorAssistanceforPeoplewithRestrictedMobility',
    'Baggage Storage': '行李寄存',
    'Baby Stroller': '婴儿推车',
    'https://www.changiairport.com/en/airport-guide/facilities-and-services/baggage-storage.html':
      'https://www.changiairport.com/zh/airport-guide/facilities-and-services/baggage-storage.html',
    'http://www.changiairport.com/en/airport-guide/special-assistance.html#anchorTravellingwithChildren':
      'http://www.changiairport.com/zh/airport-guide/special-assistance.html#anchorTravellingwithChildren',
    'GOT EVERYTHING?': '万事俱备？',
    'GOT YOUR TRAVEL ESSENTIALS?': '带好你的旅行必备品了吗？',
    'WiFi Router': '无线路由器',
    'Luggage Delivery': '行李快递',
    'https://www.changirecommends.com/owifi.aspx':
      'https://www.changirecommends.com/owifi.aspx',
    'Travel Insurance': '旅行保险',
    'https://hyfeassure.changirecommends.com/':
      'https://hyfeassure.changirecommends.com/',
    'Overseas SIM Card': '国外电话卡',
    '13 Jan - 29 May': '1月13日 - 5月29日',
    'T3, Departure Hall': '3号航站楼离境大厅',
    'Jewel (Forest Valley)': '星耀樟宜（资生堂森林谷）',
    'Jewel, Lvl 4': '星耀樟宜4楼',
    'Jewel, Lvl 5': '星耀樟宜5楼',
    'Safe Travel Journey': '樟宜安心出行',
    'SAFE TRAVEL JOURNEY': '樟宜安心出行',
    'Changi Safe Travel': '樟宜安心出行',
    'CHANGI SAFE TRAVEL': '樟宜安心出行',
    'Enchanted Forest': '奇妙森林',
    'Experience a Magical Adventure': '魔幻冒险',
    'Shiseido Forest Valley Specials': '资生堂森林谷特别活动',
    'https://www.ishopchangi.com/category/travel/prepaid-sim#1':
      'https://zh.ishopchangi.com/category/travel/prepaid-sim#1',
    'https://www.changiairport.com/en/airport-guide/facilities-and-services.html#/filter?tab=all':
      'https://www.changiairport.com/zh/airport-guide/facilities-and-services.html#/filter?tab=all',
    'Food Delivery': '美食外卖',
    'Travelling out of Singapore': '从新加坡出发',
    "Check your destination's travel advisories and requirements before your departure":
      '出发之前获取您的目的地的旅游通告及信息',
    'Use our brand new food delivery platform to order from up to 5 restaurants in a single order!':
      '我们的全新外卖平台让您在同一个订单里享受多达五家不同餐馆的美味，快来体验一下吧！',
    'COVID-19 Swab Test': 'COVID-19 拭子检测',
    'Book and pay before you arrive at Changi. ONLY for SafeTravel Pass holders':
      '使用快捷通道的访客抵达新加坡后可以在此预订并支付检测费用。',
    'COVID-19 Info Hub': 'COVID-I9信息中心',
    'Get updated information on travelling through Changi Airport':
      '获取有关Covid-19的旅游通告及其他信息。',
    VIEW: '查看',
  },
};
window.temp = {};
class _i18n {
  constructor() {
    this.language = 'en';
    this.supportedLanguages = ['en', 'zh'];
    this.updateLanguage = this.updateLanguage.bind(this);
    this.t = this.t.bind(this);
    this.updateLanguage();
  }
  updateLanguage() {
    var query = window.location.search.substring(1);
    var vars = query.split('&');
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split('=');
      if (pair[0] == 'hl') {
        if (SUPPORTE_LANGUAGES.indexOf(pair[1]) != -1) this.language = pair[1];
      }
    }
  }
  t(key) {
    return (RESOURCES[this.language] && RESOURCES[this.language][key]) || key;
  }
}

const i18n = new _i18n();
const t = i18n.t;
const updateLanguage = i18n.updateLanguage;
export { t, updateLanguage };



// WEBPACK FOOTER //
// ./src/util/i18n.js